import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NotSupportedComponent } from 'src/app/components/dialogs/not-supported/not-supported.component';
import { take } from 'rxjs';
import { LocalStorageService } from 'src/app/services/storage/storage.service';
import { MetadataService } from 'src/app/services/metadata/metadata.service';
import { AuthService } from '@auth/auth.service';

@Component({
  selector: 'mpp-experience-launcher',
  templateUrl: './experience-launcher.component.html',
  styleUrl: './experience-launcher.component.scss',
  standalone: false,
})
export class ExperienceLauncherComponent implements OnInit {
  optionsForm: FormGroup;
  public isTherapyRCCountry: boolean = false;
  public isPreTherapyCountry: boolean = false;
  private isNotSupportedModalOpen: boolean = false;

  public isPostLogin: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private metadataService: MetadataService,
    private authService: AuthService,
  ) {
    this.optionsForm = this.fb.group({
      preTherapy: [false],
      therapyPAP: [false],
      therapyRC: [false],
    });
  }

  ngOnInit(): void {
    this.isPostLogin = !!this.localStorageService.getItem('userInfo');
    this.metadataService.getMetadataFromApi().subscribe((metadata) => {
      const journeys =
        metadata?.countries.find(
          (country) => country.code === this.metadataService.getSelectedCountryId(),
        )?.supportedPatientJourneys ?? [];
      this.isTherapyRCCountry = journeys.includes('therapyRC');
      this.isPreTherapyCountry = journeys.includes('preTherapyDiagnostic');
    });
  }

  setValue(option: string): void {
    Object.keys(this.optionsForm.controls).forEach((key) => {
      this.optionsForm.get(key)?.setValue(key === option);
    });
  }

  isSubmitDisabled(): boolean {
    const formValues = this.optionsForm.value;
    return !formValues.preTherapy && !formValues.therapyPAP && !formValues.therapyRC;
  }

  onSubmit(): void {
    if (!this.isSubmitDisabled()) {
      if (this.optionsForm.value.therapyPAP) {
        if (this.localStorageService.getItem('userInfo')) {
          this.localStorageService.setAutobahnFlow();
        }
        this.router.navigate(['/account-registration']);
      } else if (this.optionsForm.value.therapyRC) {
        this.openNotSupportedModal(
          'REGISTRATION-FORM.onboarding_respiratory_machines_not_supported',
        );
      } else if (this.optionsForm.value.preTherapy) {
        this.openNotSupportedModal();
      }
    }
  }

  onCancel(): void {
    if (this.isPostLogin) {
      this.localStorageService.removeItem('userInfo');
      this.authService.logout();
    } else {
      this.router.navigate(['/']);
    }
  }

  private openNotSupportedModal(messageKey?: string): void {
    if (!this.isNotSupportedModalOpen) {
      this.isNotSupportedModalOpen = true;
      const dialogRef = this.dialog.open(
        NotSupportedComponent,
        messageKey ? { data: { messageKey } } : {},
      );
      dialogRef
        .afterClosed()
        .pipe(take(1))
        .subscribe(() => {
          this.isNotSupportedModalOpen = false;
        });
    }
  }
}
